// Import Core Components here
import React from "react";

// Import App depedency here
import { Login } from "arv-extends";
import { Input } from "arv-reactcomponents";
import RequiredField from "../../RequiredField";

const { wrapper, getFinalComponent } = Login.EmailInput;

class EmailInput extends wrapper {
  get requiredFieldClassName() {
    const { isValid } = this.state;
    const { className } = this.props;
    return (this.props.required && `${className} ${isValid}`) || "";
  }

  get inputClassName() {
    const { isValid } = this.state;
    const { className } = this.props;
    return (!this.props.required && `${className} ${isValid}`) || "";
  }

  render() {
    const { emailInputErrorMsg, email } = this.state;
    const { placeholder, name, required } = this.props;
    return (
      <div>
        <RequiredField className={this.requiredFieldClassName} required={required}>
          <Input
            className={this.inputClassName}
            name={name}
            onBlur={this.onBlur}
            onChange={this.validateEmail}
            placeholder={placeholder}
            type="email"
            value={email}
            ref={values => {
              this.validateEmailFieldRef = values;
            }}
            validateWithPattern={[
              {
                pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                msg: "Enter a valid email address.",
              },
            ]}
          />
        </RequiredField>
        <div className={`nw-form-err-msg ${this.state.emailErrorClass}`}>
          {emailInputErrorMsg}
        </div>
      </div>
    );
  }
}

Login.EmailInput.component = getFinalComponent(EmailInput);
